import { render, staticRenderFns } from "./EventGuests.vue?vue&type=template&id=234b8aa4&scoped=true"
import script from "./EventGuests.vue?vue&type=script&lang=js"
export * from "./EventGuests.vue?vue&type=script&lang=js"
import style0 from "./EventGuests.vue?vue&type=style&index=0&id=234b8aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b8aa4",
  null
  
)

export default component.exports